// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterFieldValue } from "../../types";

const matterFieldValuesModule = {
  async findByMatterId(matterId: string): Promise<MatterFieldValue[]> {
    try {
      const result = await sql`
        SELECT * FROM matter_field_values
        WHERE matter_id = ${matterId}
      `;
      return (result || []) as MatterFieldValue[];
    } catch (error) {
      console.error('Error fetching matter field values:', error);
      return [];
    }
  },
  
  async create(data: Omit<MatterFieldValue, 'id' | 'created_at' | 'updated_at'>): Promise<MatterFieldValue> {
    const result = await sql`
      INSERT INTO matter_field_values (matter_id, field_id, value_text, value_number, value_date, value_boolean, value_json)
      VALUES (${data.matter_id}, ${data.field_id}, ${data.value_text}, ${data.value_number}, 
              ${data.value_date}, ${data.value_boolean}, ${data.value_json ? JSON.stringify(data.value_json) : null})
      RETURNING *
    `;
    return result[0] as MatterFieldValue;
  },
  
  async upsert(data: Omit<MatterFieldValue, 'id' | 'created_at' | 'updated_at'>): Promise<MatterFieldValue> {
    const result = await sql`
      INSERT INTO matter_field_values (matter_id, field_id, value_text, value_number, value_date, value_boolean, value_json)
      VALUES (${data.matter_id}, ${data.field_id}, ${data.value_text}, ${data.value_number}, 
              ${data.value_date}, ${data.value_boolean}, ${data.value_json ? JSON.stringify(data.value_json) : null})
      ON CONFLICT (matter_id, field_id) 
      DO UPDATE SET 
          value_text = EXCLUDED.value_text,
          value_number = EXCLUDED.value_number,
          value_date = EXCLUDED.value_date,
          value_boolean = EXCLUDED.value_boolean,
          value_json = EXCLUDED.value_json,
          updated_at = now()
      RETURNING *
    `;
    return result[0] as MatterFieldValue;
  },
  
  async delete(id: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_field_values
      WHERE id = ${id}
    `;
    return result.count > 0;
  },
  
  async deleteByMatterId(matterId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_field_values
      WHERE matter_id = ${matterId}
    `;
    return result.count > 0;
  }
};

export type MatterFieldValuesModule = typeof matterFieldValuesModule;

export function registerMatterFieldValues(db: { matterFieldValues?: MatterFieldValuesModule }) {
  db.matterFieldValues = matterFieldValuesModule;
}

export { matterFieldValuesModule as matterFieldValues };
